import { render, staticRenderFns } from "./topo-chart.vue?vue&type=template&id=147c8448&"
import script from "./topo-chart.vue?vue&type=script&lang=ts&"
export * from "./topo-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports